import { render } from "./FluidBox.vue?vue&type=template&id=3fc55114&scoped=true"
import script from "./FluidBox.vue?vue&type=script&lang=js"
export * from "./FluidBox.vue?vue&type=script&lang=js"

import "./FluidBox.vue?vue&type=style&index=0&id=3fc55114&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3fc55114"

export default script